export enum RootIndexMutationTypes {
  SET_LIST_USER = 'SET_LIST_USER',
  SET_LIST_USER_SELECTED = 'SET_LIST_USER_SELECTED',
  SET_AVATAR_USERS = 'SET_AVATAR_USERS',
}
